import { PagedResult } from '@csp/csp-common-model';
import { StudyFilesV1 } from '@csp/dmdp-api-file-storage-studydocs-dto';
import { StudyDocumentsFile } from '../model/StudyDocumentsFile';
import { StudyDocumentsFileMapper } from './StudyDocumentsFileMapper';

const from = (studyFilesV1: StudyFilesV1): PagedResult<StudyDocumentsFile> => ({
  ...studyFilesV1.paging,
  data: studyFilesV1.studyFiles.map(StudyDocumentsFileMapper.from),
});

export const PagedStudyDocumentsFilesMapper = {
  from,
};
